import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { CheckboxField, Dropdown, withApplicationContext } from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { NEARBY_SEARCH_RADIUS_OPTIONS } from '../../constants/filters'
import { checkIsNearbySearch } from '../../util/nearbyCheckbox'
import { getDefaultNearbyRadius } from '../../util/seekConversion'
import styles from './styles.scss'
const cx = classnames.bind(styles)

class NearbyCheckbox extends Component {
  static propTypes = {
    filters: PropTypes.object.isRequired,
    assets: PropTypes.object.isRequired,
    elmId: PropTypes.string.isRequired,
    updateFiltersAction: PropTypes.func.isRequired,
    applicationContext: PropTypes.object.isRequired,
  }

  toggleNearbySearch = isNearbySearch => {
    const useNearbySearch = isNearbySearch ? 'y' : 'n'
    this.props.updateFiltersAction({ useNearbySearch })
  }

  setNearbySearchRadius = (_, { value: nearbySearchRadius }) => {
    this.props.updateFiltersAction({ nearbySearchRadius })
  }

  onChange = (_, { checked }) => {
    this.toggleNearbySearch(checked)
  }

  render() {
    const { elmId, assets, filters, applicationContext } = this.props
    const { fetchProgress } = assets
    const { useNearbySearch, nearbySearchRadius, globalSearch } = filters
    const isNearbySearch = useNearbySearch === 'y'
    const isGlobalSearch = globalSearch === 'y'
    const showNearbyCheckbox =
      checkIsNearbySearch(filters.city, filters.zip, filters.county) &&
      !isGlobalSearch
    const nearbySearchValue =
      nearbySearchRadius ||
      getDefaultNearbyRadius(applicationContext.featureFlags) // We're adding the default here because we don't want to encode this on all search queries

    return (
      <div className={cx('checkbox')}>
        {showNearbyCheckbox && (
          <>
            <CheckboxField
              hideLabel
              elmId={`${elmId}_nearby_search`}
              checkboxLabel='Include nearby results within'
              checked={isNearbySearch}
              onChange={this.onChange}
              disabled={fetchProgress.loading}
            />

            <Dropdown
              inline
              className={cx(
                'u-ml-1',
                'nearby-dropdown',
                'temporary-fix-down-caret-alignment'
              )}
              data-elm-id={`${elmId}_nearby_search_radius_dropdown`}
              disabled={!isNearbySearch}
              value={nearbySearchValue}
              onChange={this.setNearbySearchRadius}
              options={NEARBY_SEARCH_RADIUS_OPTIONS}
            />
          </>
        )}
      </div>
    )
  }
}

export default withApplicationContext(NearbyCheckbox)
